export class ReportPeriod {

    key: string;
    label: string;
    dictionaryKey: string;

    constructor(key: string, label: string, dictionaryKey: string) {
      this.key = key;
      this.label = label;
      this.dictionaryKey = dictionaryKey;
    }
}
